import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id ABFAD078-0E10-4293-94AD-16871B75E51F
 * name battery-alert
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/battery-alert.svg
 * tags
 * - Battery 
 * - Home Automation 
 * - Alert / Error 
 */
export const BatteryAlertIcon = createSvgIcon(<><path d="M13 14H11V8H13M13 18H11V16H13M16.7 4H15V2H9V4H7.3C6.6 4 6 4.6 6 5.3V20.6C6 21.4 6.6 22 7.3 22H16.6C17.3 22 17.9 21.4 17.9 20.7V5.3C18 4.6 17.4 4 16.7 4Z" /></>, 'BatteryAlertIcon');
export default BatteryAlertIcon